export default __webpack_public_path__ + "static/logo-d2f15d3d4609de094f2b0e5de885341c.png";